import Vue from 'vue';

const LOGIN = '/user/login';
const REGISTER = '/user/register';
const DELETE = '/user/';

class UserService {
    async login(user) {
        return await Vue.prototype.$axios.post(LOGIN, user);
    }

    async register(user) {
        return await Vue.prototype.$axios.post(REGISTER, user);
    }

    async delete(data) {
        return await Vue.prototype.$axios.delete(DELETE, { data: data });
    }
}

export default new UserService();
